import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { List, ListItem, ListItemText, Divider } from '@material-ui/core';
import { styles } from './CommonDesign.styles';
import Button from '../Button';
import Spinner from '../Spinner';
import Paper from '../Paper';
import Switch from '../Switch';
import { UNIT } from '../../constants';
import Viewer from '../Viewer';

function CommonDesign(props) {
  const {
    classes,
    title,
    child,
    onClick,
    onChange,
    checked,
    isLoading,
    disabled,
    src,
    hasBottomNavigation,
    handleChange,
    selected,
    config = true,
    withoutSaveButton = false,
    isConfig = false,
    isAddition = false
  } = props;

  const renderRightPart = (
    <div className='col-md-6 col-lg-5 col-xl-4 pr-0'>
      <div elevation={1} className={`${classes.paperStyle} ${hasBottomNavigation && 'pt-3'}`}>
        {hasBottomNavigation && config &&
          <Viewer
            value={selected}
            onChange={handleChange}
            buttonList={['Cash back', 'Produits']}
            loyaltyProgram={true}
          />
        }
        {config &&
          <>
            <List className={`classes.spaceLeft ${hasBottomNavigation && 'mt-2'}`} key='checked'>
              <ListItem>
                <ListItemText primary={<p className={classes.listItemStyle}>{title}</p>} />
                <Switch
                  onChange={onChange}
                  checked={checked}
                  color='primary'
                  className={classes.switch}
                />
              </ListItem>
            </List>
            <Divider className={!hasBottomNavigation && classes.hrStyle} />{' '}
          </>
        }
        <div className={isConfig ? classes.configPaper : isAddition ? classes.additionPaper : classes.paper}>
          <div>{child}</div>
        </div>

        {!withoutSaveButton &&
          <div className='d-flex justify-content-center mb-4'>
            {isLoading ? (
              <center>
                <Spinner className={classes.progress} />
              </center>
            ) : (
              <Button
                onClick={onClick}
                className={`${classes.buttonStyle} ${disabled && classes.disabledButton}`}
                disabled={disabled}
              >
                ENREGISTRER
              </Button>
            )}
          </div>
        }
      </div>
    </div>
  );

  const renderLeftPart = (
    <div className='col-md-6 col-lg-7 col-xl-8 mb-2 mb-md-0 h-100 pr-md-0'>
      <div className={classes.designStyle}>
        <img src={src} alt='' style={{ height: UNIT * 36 }} />
      </div>
    </div>
  );

  return (
    <Paper className={`col-12 px-0 my-3 ${classes.body}`}>
      <div className={`col-12 w-100 h-100 d-flex align-items-stretch ${classes.marginStyle}`}>
        {renderLeftPart}
        <Divider orientation="vertical" flexItem />
        {renderRightPart}
      </div>
    </Paper>
  );
}




export default withStyles(styles)(CommonDesign);
